import styled from "styled-components";

export const ContainerCardResult = styled.div<{render: string}>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 0px 0px 0px;
  width: 295px;
  min-height: 148px;
  height: auto;
  background: #f9fafb;
  border-radius: 8px 8px 12px 12px;
  box-shadow: 4px 4px 10px #e1e1e3;
  margin: 0px 14px 14px 0px;
  overflow: hidden;

  @media screen and (min-width: 1600px) {
    width: 400px;
  }

  @media screen and (max-width: 1500px) {
    width: 295px;
  }
`;

export const CardResultHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 28px;
  background: rgba(10, 81, 144, 0.1);
  border-radius: 4px;
  padding: 4px 8px;
  color: #0a5190;
  margin-left: 20px;
`;

export const CardResultBody = styled.div<{position: number}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 12px;
  margin-left: 20px;
  margin-right: 16px;
  height: 100%;
  flex: 1;
`;

export const FotoUser = styled.img`
  width: 6px;
`;

export const SubDesc = styled.p`
  margin: 0px;
  color: #475467;
  font-size: 13px;
`;

export const InfoResults = styled.div<{render: string, isLastConsult: boolean}>`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin-top: 14px;
  height: 36px;
  background-color: ${props => props.render === "CC" && props.isLastConsult ? "#0d6cbf" : props.render === "CC" && !props.isLastConsult ? "#9CA3AF" :  "#409FF2" };
  border-radius: 0px 0px 12px 12px;
  color: white;
  cursor: pointer;
  box-shadow: 4px 4px 6px #e1e1e3;
  padding: 0 12px;

  @media screen and (min-width: 1600px) {
    width: 100%;
  }

  @media screen and (max-width: 1500px) {
    width: 100%;
  }
`;
